import API from '@/interceptors/Api';

type SendSuggestionServiceParams = {
  message: string;
}

export const sendSuggestionService = async (params: SendSuggestionServiceParams) => {
  const { message } = params;
  const response = await API.post('/support/suggestions', { message });
  return response;
};
